export const getTranslation = () => {
  const langs: any = { 
    de: {
      "airport": "Flughafen",
      "agricultural": "Landwirtschaftlich",
      "construction": "Bau und öffentliche Arbeiten",
      "dealer": "Konzessionär",
      "builder": "Bauherr",
      "waste": "Umwelt / Abfall",
      "greenSpace": "Grünflächen",
      "rail": "Schiene",
      "industry": "Industrie",
      "rental": "Vermietungsunternehmen",
      "lifting": "Handhabung / Heben / Anheben",
      "maritime": "Maritim",
      "private": "Privatperson",
      "services": "Dienstleistungen / Shop",
      "transportation": "Transport"
    },
    en: {
      "airport": "Airport",
      "agricultural": "Agricultural",
      "construction": "Construction and public works",
      "dealer": "Concessionaire",
      "builder": "Builder",
      "waste": "Environment / Waste",
      "greenSpace": "Green spaces",
      "rail": "Rail",
      "industry": "Industry",
      "rental": "Rental company",
      "lifting": "Handling / Lifting / Elevating",
      "maritime": "Maritime",
      "private": "Private individual",
      "services": "Services / Shop",
      "transportation": "Transportation"
    },
    es: {
      "airport": "Aeropuerto",
      "agricultural": "Agrícola",
      "construction": "Construcción y obras públicas",
      "dealer": "Concesionario",
      "builder": "Constructor",
      "waste": "Medio Ambiente / Residuos",
      "greenSpace": "Espacios verdes",
      "rail": "Vía",
      "industry": "Industria",
      "rental": "Empresa de alquiler",
      "lifting": "Manejo / Levantamiento / Elevación",
      "maritime": "Marítimo",
      "private": "Individuo privado",
      "services": "Servicios / Tienda",
      "transportation": "Transporte"
    },
    fr: {
      "airport": "Aéroportuaire",
      "agricultural": "Agricole",
      "construction": "BTP",
      "dealer": "Concessionnaire",
      "builder": "Constructeur",
      "waste": "Environnement / Déchêts",
      "greenSpace": "Espaces Verts",
      "rail": "Ferroviaire",
      "industry": "Industrie",
      "rental": "Loueurs",
      "lifting": "Manutention / Levage / Élévateur",
      "maritime": "Maritime",
      "private": "Particuliers",
      "services": "Services / Commerces",
      "transportation": "Transports"
    },
    it:  {
      "airport": "Aeroporto",
      "agricultural": "Agricolo",
      "construction": "Costruzione e lavori pubblici",
      "dealer": "Concessionario",
      "builder": "Costruttore",
      "waste": "Ambiente / Rifiuti",
      "greenSpace": "Spazi verdi",
      "rail": "Binario",
      "industry": "Industria",
      "rental": "Azienda di noleggio",
      "lifting": "Gestione / Sollevamento / Elevazione",
      "maritime": "Marittimo",
      "private": "Individuo privato",
      "services": "Servizi / Negozio",
      "transportation": "Trasporto"
    },
    nl:  {
      "airport": "Vliegveld",
      "agricultural": "Landbouw",
      "construction": "Bouw en openbare werken",
      "dealer": "Concessiehouder",
      "builder": "Bouwer",
      "waste": "Omgeving / Afval",
      "greenSpace": "Groene ruimtes",
      "rail": "Spoor",
      "industry": "Industrie",
      "rental": "Verhuurbedrijf",
      "lifting": "Behandeling / Tillen / Optillen",
      "maritime": "Maritiem",
      "private": "Particulier",
      "services": "Diensten / Winkel",
      "transportation": "Vervoer"
    },
    pl: {
      "airport": "Lotnisko",
      "agricultural": "Rolniczy",
      "construction": "Budownictwo i prace publiczne",
      "dealer": "Koncesjonariusz",
      "builder": "Budowniczy",
      "waste": "Środowisko / Odpady",
      "greenSpace": "Zielone przestrzenie",
      "rail": "Kolej",
      "industry": "Przemysł",
      "rental": "Firma wynajmująca",
      "lifting": "Obsługa / Podnoszenie / Wznoszenie",
      "maritime": "Morski",
      "private": "Osoba prywatna",
      "services": "Usługi / Sklep",
      "transportation": "Transport"
    },
    ro: {
      "airport": "Aeroport",
      "agricultural": "Agricol",
      "construction": "Construcții și lucrări publice",
      "dealer": "Concesionar",
      "builder": "Constructor",
      "waste": "Mediu / Deșeuri",
      "greenSpace": "Spatii verzi",
      "rail": "Cale ferată",
      "industry": "Industrie",
      "rental": "Companie de închirieri",
      "lifting": "Manipulare / Ridicare / Elevare",
      "maritime": "Maritim",
      "private": "Persoană fizică",
      "services": "Servicii / Magazin",
      "transportation": "Transport"
    }
  };
  return langs;
};